export default function formatPercent(libelle) {
  return libelle + '%';
}
